__turbopack_context__.v({
  "className": "bricolage_grotesque_e46326b3-module__HoT5eG__className",
});
